import styled from 'styled-components';
import { Palette } from 'config';

export const Header = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;

  width: 100%;

  background: #ffffff;
  padding: 16px 16px 16px 24px;

  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
`;
export const Message = styled.span`
  font-weight: 400;
  font-size: 12px;
  line-height: 32px;
  width: 100%;
  height: 32px;
  color: ${Palette.PrimaryGray._500};
  text-transform: none;
  background: ${Palette.PrimaryGray._000};

  ::before {
    content: 'i';
    text-transform: none;
    color: white;
    background-color: ${Palette.PrimaryGray._400};
    padding-left: 6px;
    padding-right: 6px;
    border-radius: 50%;
    margin-right: 8px;
    margin-left: 24px;
  }
`;

export const HeaderTitle = styled.h2`
  font-weight: 500;
  font-size: 18px;
  line-height: 24px;
  color: ${() => Palette.PrimaryGray._900};
  margin: 0;
`;

export const HeaderCloseButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;

  cursor: pointer;

  transition: 0.1s ease-in-out;

  width: 25px;
  height: 25px;
  border: 1px solid #ffffff;
  border-radius: 50%;
  background: transparent;
  padding: 0;
  svg {
    fill: ${() => Palette.PrimaryGray._500};
  }

  &:hover {
    svg {
      fill: ${() => Palette.Primary._500};
    }
  }

  &:focus,
  &:active {
    outline: none;
    border-color: ${() => Palette.PrimaryGray._400};
    box-shadow: 0px 0px 0px 3px rgba(59, 137, 246, 0.16);
  }
`;
